import * as yup from 'yup';
import { AccountDTO } from '../../../../../../../Profile/Accounts/api/useAccountsQuery';

interface AnnuityDTO extends AccountDTO {
  AccountPortfolio: {
    AccountPortfolioByTaxStatuses: {
      AssetAllocation: {
        id: number;
        y: number;
      }[];
      HypotheticalReturn: number | null;
    }[];
  };
}

export interface Purchase {
  SourceAccounts: {
    Id: string;
    EntityId: string;
    IsSimulatedSource: boolean;
    SimulatedAccountType: number;
  }[];
  IsApplied: boolean;
  PurchaseYear: number | null;
  PurchaseAmount: number | null;
  UseFullAccountValue: boolean;
  Annuity: AnnuityDTO | null;
}

export interface WhatIfDTO {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  Purchases: Purchase[];
}

export interface FormValues extends WhatIfDTO {}

export const FORM_SCHEMA = yup.object().shape({
  Purchases: yup.array().of(
    yup.object().shape({
      Annuity: yup
        .object()
        .nullable()
        .required('Please add the annuity account details.'),
      SourceAccounts: yup
        .array()
        .of(yup.object())
        .nullable()
        .min(1, 'You need to select at least one account.'),
      PurchaseYear: yup
        .string()
        .nullable()
        .required('This field is required.'),
      PurchaseAmount: yup
        .number()
        .nullable()
        .when('UseFullAccountValue', {
          is: false,
          then: yup
            .number()
            .nullable()
            .required('This field is required.'),
        }),
    }),
  ),
});
